import React, {useEffect, useState} from 'react'
import {Button} from './Button'
import {Logo} from './Logo'
import {ArrowRight} from './icons'
import {appUrl, signupModalHref} from './constants'

function HeaderV2({onContact}) {
  const [scrolled, setScrolled] = useState(false)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20)
    onScroll()
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  useEffect(() => {
    if (!open) return undefined
    document.body.style.overflow = 'hidden'
    const onKey = event => {
      if (event.key === 'Escape') setOpen(false)
    }
    window.addEventListener('keydown', onKey)
    return () => {
      document.body.style.overflow = ''
      window.removeEventListener('keydown', onKey)
    }
  }, [open])

  const links = [
    {href: '#features', label: 'Features'},
    {href: '#pricing', label: 'Pricing'},
  ]

  return (
    <>
      <header className={`hlm-nav ${scrolled ? 'is-scrolled' : ''}`}>
        <div className="hlm-container hlm-nav-row">
          <Logo />
          <nav className="hlm-links" aria-label="Primary navigation">
            {links.map(link => (
              <a key={link.href} href={link.href}>
                {link.label}
              </a>
            ))}
          </nav>
          <div className="hlm-actions">
            <a className="hlm-signin" href={`${appUrl}/auth/login`}>
              Sign in
            </a>
            {/* <Button variant="secondary" size="sm" onClick={onContact}>
              Contact us
            </Button> */}
            <Button href={signupModalHref} size="sm">
              Try it free
              <ArrowRight />
            </Button>
          </div>
          <button className="hlm-menu-btn" aria-label="Open menu" onClick={() => setOpen(true)}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true">
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          </button>
        </div>
      </header>

      <aside className={`hlm-mobile-drawer ${open ? 'is-open' : ''}`} role="dialog" aria-modal="true" aria-label="Mobile menu">
        <div className="hlm-mobile-top">
          <Logo />
          <button className="hlm-modal-close" aria-label="Close menu" onClick={() => setOpen(false)}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true">
              <line x1="6" y1="6" x2="18" y2="18" />
              <line x1="18" y1="6" x2="6" y2="18" />
            </svg>
          </button>
        </div>
        <nav className="hlm-mobile-nav">
          {links.map(link => (
            <a key={link.href} href={link.href} onClick={() => setOpen(false)}>
              {link.label}
            </a>
          ))}
          <a href={`${appUrl}/auth/login`} onClick={() => setOpen(false)}>
            Sign in
          </a>
        </nav>
        <div className="hlm-mobile-cta">
          {/* <Button
            variant="secondary"
            size="sm"
            full
            onClick={() => {
              setOpen(false)
              onContact()
            }}>
            Contact us
          </Button> */}
          <Button href={signupModalHref} size="sm" full>
            Try it free
            <ArrowRight />
          </Button>
        </div>
      </aside>
    </>
  )
}

export default HeaderV2
